import React from 'react';
import '../styles/LandingPage.css';
import AnavuLandingContent from '../components/AnavuLandingContent';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const LandingPage = () => {
    return (
        <div className="landing-page">
            <Navbar />
            <main className="main-content">
               <AnavuLandingContent />
            </main>
            <Footer />
        </div>
    );
};

export default LandingPage;
